<template lang="pug">
.row
  .col-12.mb-3
    .documents__menu-tab
      ul#my-tab.nav.nav-tabs(role='tablist')
        li.nav-item(role='presentation')
          router-link.nav-link(
            :class='{ active: isTabActive("inbox") }'
            :to='{ name: "business.documents.inbox" }'
          ) {{ $t('received') }}
        li.nav-item(role='presentation')
          router-link.nav-link(
            :class='{ active: isTabActive("sent") }'
            :to='{ name: "business.documents.sent" }'
          ) {{ $t('sent') }}
        li.nav-item(role='presentation')
          router-link.nav-link(
            :class='{ active: isTabActive("waiting-review") }'
            :to='{ name: "business.documents.waiting-review" }'
            v-if='canAccessWaitingReview'
          ) {{ $t('waiting-review') }}
        li.nav-item(role='presentation')
          router-link.nav-link(
            :class='{ active: isTabActive("draft") }'
            :to='{ name: "business.documents.draft" }'
            v-if='canAcessDraftsAndTemplates'
          ) {{ $t('draft') }}
        li.nav-item(role='presentation')
          router-link.nav-link(
            :class='{ active: isTabActive("template") }'
            :to='{ name: "business.documents.template" }'
            v-if='canAcessDraftsAndTemplates'
          ) {{ $t('model') }}
        //- li.nav-item(role='presentation')
          router-link.nav-link(
            :class='{ active: isTabActive("bulk-send") }'
            :to='{ name: "business.documents.bulk-send" }'
          )
            | {{ $t('bulkSend') }}
            span.badge.documents__new-badge.ms-2 {{ $t('newBadge') }}
    #myTabContent.tab-content.pt-3
      router-view
</template>

<script>
import { getAllowedVisibilities } from '@/modules/business/common/envelopeVisibility';
import PermissionsService from '@/services/PermissionsService';
import ApiPermissions from '@/enums/ApiPermissions';

export default {
  name: 'DocumentsPage',
  computed: {
    canAccessWaitingReview() {
      // must be visibility active on organization to submit envelopes to review
      const teamsVisibilityConfig = getAllowedVisibilities(
        this.$store.state.organizations.selected
      );
      return teamsVisibilityConfig.length > 0;
    },
    canAcessDraftsAndTemplates() {
      return (
        // if user has only envelope-reviewer role, cannot access drafts and templates
        PermissionsService.can(
          this.$root.user,
          ApiPermissions.ENVELOPE_CREATE
        ) ||
        PermissionsService.can(this.$root.user, ApiPermissions.ENVELOPE_UPDATE)
      );
    },
  },
  methods: {
    isTabActive(type) {
      return this.$route.name.split('.').pop() === type;
    },
  },
};
</script>
<style lang="stylus">
.documents__menu-tab
  overflow-x: auto
  &::-webkit-scrollbar
    height: 5px
  .nav-tabs
    min-width: 100%
    display: inline-flex
.documents__new-badge
  background-color: #0B5C4E
  color: #FFFFFF
  font-size: 0.65rem
  vertical-align: middle
</style>
